import { Link } from 'react-router-dom';

const footerLinks = [
  { label: 'All Games', path: '/games' },
  { label: 'New Games', path: '/new-games' },
  { label: 'About', path: '/about' },
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Terms', path: '/terms' },
  { label: 'Disclaimer', path: '/disclaimer' },
  { label: 'Responsible Gaming', path: '/responsible-gaming' },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="px-4 py-8">
        <Link to="/" className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-gamepad-line text-sm text-white"></i>
          </div>
          <span className="font-heading font-bold text-[15px] text-background-50">
            All Yono Games
          </span>
        </Link>
        <p className="text-background-400 text-xs leading-relaxed mb-5">
          Your trusted directory for Yono Games, Yono Apps, and Android game downloads for Indian players.
        </p>

        <div className="grid grid-cols-2 gap-x-6 gap-y-2 mb-6">
          {footerLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="text-background-400 hover:text-background-100 text-xs transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </div>

        <p className="text-background-500 text-[11px] leading-relaxed mb-2">
          This website is an independent directory. We are not the official owner of listed games. Bonus amounts, deposit requirements and withdrawal terms may change. Review the current offer terms before registering or depositing. Play responsibly.
        </p>
      </div>

      <div className="border-t border-background-800 px-4 py-3">
        <p className="text-background-600 text-[11px] text-center">
          &copy; {new Date().getFullYear()} All Yono Games. All rights reserved.
        </p>
      </div>
    </footer>
  );
}